import Api, { baseURL } from '../Api'

const BASE = `${baseURL('v2')}/{departamento}/produtividade/resumos`

export default {
  createServicoExtra(resumoId, params) {
    return Api.post(`${BASE}/${resumoId}/pontuacoes/servico-extra`, params)
  },

  createFalta(resumoId, params) {
    return Api.post(`${BASE}/${resumoId}/pontuacoes/falta`, params)
  },

  createAvulso(resumoId, params) {
    return Api.post(`${BASE}/${resumoId}/pontuacoes/avulso`, params)
  },
}
